// 8 つの TA ボタンのメタデータ。spec §4.1 と D1 button_events.button_type の enum に対応。
// label は i18n キー、icon は絵文字 (locale 非依存なのでハードコード)。

import type { ButtonType } from '@solo-webinar-copilot/shared';
import type { MessageKey } from '@solo-webinar-copilot/i18n';

export interface ButtonDef {
  type: ButtonType;
  icon: string;
  labelKey: MessageKey;
}

export const BUTTONS: readonly ButtonDef[] = [
  { type: 'slow_down', icon: '🙋', labelKey: 'in_client.button.slow_down' },
  { type: 'dont_understand', icon: '🤔', labelKey: 'in_client.button.dont_understand' },
  { type: 'done', icon: '✅', labelKey: 'in_client.button.done' },
  { type: 'look_at_me', icon: '👀', labelKey: 'in_client.button.look_at_me' },
  { type: 'ok_understood', icon: '💡', labelKey: 'in_client.button.ok_understood' },
  { type: 'emergency', icon: '🆘', labelKey: 'in_client.button.emergency' },
  { type: 'have_question', icon: '❓', labelKey: 'in_client.button.have_question' },
  { type: 'need_break', icon: '⏸️', labelKey: 'in_client.button.need_break' },
];

// 一括リセットのデフォルト対象 (spec §4.1: 「終わった」「OK・分かった」)
export const PROGRESS_BUTTON_TYPES: readonly ButtonType[] = [
  'done',
  'ok_understood',
];
